"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpretDenyListNode = void 0;
const matchStatus_1 = require("./matchStatus");
/**
 * Checks if params match blacklist node rules
 * @param ruleNode
 * @param context
 */
function interpretDenyListNode(ruleNode, context, interpretChildren) {
    const targetValue = context.getProperty(ruleNode.target);
    if (targetValue == null) {
        context.sendError(`Property ${ruleNode.target} not found for dynamic value ${context.getDynamicValueName()} `);
        context.addResolutionLog(`Context missing target property: ${ruleNode.target}`);
        return matchStatus_1.error();
    }
    const inDenyList = ruleNode.list.some(value => String(targetValue) === String(value));
    context.addResolutionLog(inDenyList
        ? `FAILURE: ${targetValue} in deny list`
        : `SUCCESS: ${targetValue} not in deny list`);
    return !inDenyList ? interpretChildren(ruleNode, context) : matchStatus_1.failure();
}
exports.interpretDenyListNode = interpretDenyListNode;
//# sourceMappingURL=denyList.js.map